export default __webpack_public_path__ + "static/media/eQTL.9661d054.svg";